<!-- Navigation Drawer Template -->
<template>
  <v-navigation-drawer
    color="transparent"
    fixed
    permanent
    scrollable
    clipped
    floating
    app
    dense
    :mini-variant="mini"
    :width="220"
    mini-variant-width="64"
    class="navigation-drawer"
  >
    <!-- Logo -->
    <div class="fixed-image" :class="{ 'mini-mode': mini }">
      <img
        :style="{ width: mini ? '32px' : '100%' }"
        :src="logoSrc"
        alt="Sabira Logo"
      />
    </div>

    <!-- Search field - only show when expanded -->
    <v-slide-x-transition>
      <v-text-field
        v-if="!mini"
        dense
        prepend-inner-icon="mdi-magnify"
        clearable
        @click:clear="clearSearch"
        placeholder="Pretraga"
        outlined
        hide-details
        class="fixed-filter pb-4"
        v-model="searchQuery"
      ></v-text-field>
    </v-slide-x-transition>

    <!-- Navigation list -->
    <div class="navigation-list-container">
      <v-list nav rounded class="navigation-list">
        <v-tooltip
          v-for="(nav, index) in filteredNavigationItems"
          :key="'nav_' + index"
          right
          color="#e9c46a"
          open-on-hover
          open-delay="250"
          :disabled="!mini"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-list-item
              :to="nav.route"
              class="nav-list-item"
              @click="scrollToTop"
              :class="{ 'mini-list-item': mini }"
              v-bind="attrs"
              v-on="mini ? on : {}"
            >
              <div
                class="icon-wrapper pa-2 primary mr-2"
                :class="{ 'mini-icon-wrapper': mini }"
              >
                <sabira_icon
                  :strokewidth="3"
                  :icon="nav.icon"
                  fill="#fff"
                  :width="18"
                  :height="18"
                />
              </div>
              <v-list-item-content v-if="!mini">
                <v-list-item-title
                  style="font-family: 'Open Sans'; font-weight: 500;"
                  >{{ nav.name }}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </template>
          <span>{{ nav.name }}</span>
        </v-tooltip>
      </v-list>
    </div>

    <!-- Toggle button -->
    <v-btn icon small @click.stop="mini = !mini" class="toggle-btn">
      <v-icon color="primary" small>
        {{ mini ? "mdi-chevron-right" : "mdi-chevron-left" }}
      </v-icon>
    </v-btn>
  </v-navigation-drawer>
</template>
<script>
import logoSrc from "@/assets/images/sabira_logo_full.svg";

export default {
  name: "NavigationDrawer",

  components: {
    sabira_icon: () => import("@/components/sabira_icon"),
  },

  data() {
    return {
      logoSrc,
      navigation: null,
      searchQuery: "",
      mini: false,
      items: [
        {
          route: "/start",
          name: "Start",
          icon: "chart",
        },
        {
          route: "/artikli",
          name: "Artikli",
          icon: "product",
        },
        {
          route: "/klijenti",
          name: "Klijenti",
          icon: "client",
        },
        {
          route: "/dobavljaci",
          name: "Dobavljači",
          icon: "supplier",
        },
        {
          route: "/narudzbe",
          name: "Narudžbe",
          icon: "order",
        },
        {
          route: "/zalihe",
          name: "Zalihe",
          icon: "stock",
        },
        {
          route: "/fakture",
          name: "Fakture",
          icon: "invoice",
        },
        {
          route: "/ponude",
          name: "Ponude",
          icon: "offer",
        },
        {
          route: "/ugovori",
          name: "Ugovori",
          icon: "contract",
        },
        {
          route: "/nalozi",
          name: "Nalozi",
          icon: "work_order",
        },
        {
          route: "/sredstva",
          name: "Sredstva",
          icon: "asset",
        },
        {
          route: "/marketing-budzet",
          name: "Marketing",
          icon: "marketing",
        },
        {
          route: "/hr",
          name: "HR",
          icon: "hr",
        },
        {
          route: "/memorandumi",
          name: "Memorandumi",
          icon: "memo",
        },
        {
          route: "/biljeske",
          name: "Bilješke",
          icon: "todo",
        },
        {
          route: "/kalendar",
          name: "Kalendar",
          icon: "calendar",
        },
        {
          route: "/accounts",
          name: "Firme",
          icon: "account",
          restricted: true,
        },
        {
          route: "/users",
          name: "Korisnici",
          icon: "user",
          restricted: true,
        },
        {
          route: "/podrska",
          name: "Podrška",
          icon: "customer-support",
          restricted: true,
        },
      ],
    };
  },

  computed: {
    navigation_items() {
      if (this.$store.getters.user.id !== 1) {
        return this.items.filter((x) => x.restricted !== true);
      } else {
        return this.items;
      }
    },

    filteredNavigationItems() {
      return this.navigation_items.filter((nav) => {
        return nav.name
          .toLowerCase()
          .includes((this.searchQuery || "").toLowerCase());
      });
    },
  },

  methods: {
    get_image_background(image) {
      return (
        "width: 100%;height:100%;background-image: url('" +
        image +
        "');background-size: contain;background-position:center;"
      );
    },

    clearSearch() {
      this.searchQuery = "";
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },

    get_avatar_initials() {
      let str = this.$store.getters.user.name;
      let initials = str
        .split(/\s/)
        .reduce((response, word) => (response += word.slice(0, 1)), "");
      return initials.toUpperCase();
    },

    get_username() {
      return this.$store.getters.user.username !== null
        ? this.$store.getters.user.username
        : "";
    },
  },

  created() {
    const savedMiniState = localStorage.getItem("navigationMiniState");
    if (savedMiniState !== null) {
      this.mini = JSON.parse(savedMiniState);
    }
  },

  watch: {
    mini(newValue) {
      localStorage.setItem("navigationMiniState", JSON.stringify(newValue));
    },
  },
};
</script>
<style scoped>
:root {
  /* --drawer-transition-speed: 0s; */
  --header-height: 64px;
  --search-height: 6.5rem;
  --mini-margin: 5rem;
}

.navigation-drawer {
  transition: all var(--drawer-transition-speed) cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.container {
  display: flex;
  justify-content: left;
  align-items: left;
}

.fixed-image {
  position: fixed;
  top: 20px;
  left: 5rem;
  width: 30%;
  background: transparent;
  z-index: 2;
  transition: all var(--drawer-transition-speed) cubic-bezier(0.4, 0, 0.2, 1);
}

.fixed-image.mini-mode {
  left: 58%; /* Center horizontally */
  transform: translateX(-50%); /* Offset by half width for true centering */
  width: 32px; /* Match the mini width specified in template */
}

.fixed-image img {
  transition: all var(--drawer-transition-speed) cubic-bezier(0.4, 0, 0.2, 1);
}

.fixed-filter {
  margin-top: 2rem;
  margin-bottom: 1.5rem;
  position: fixed;
  top: 100px;
  z-index: 2;
  margin-left: 0.5rem;
  width: 93%;
  transition: all var(--drawer-transition-speed) cubic-bezier(0.4, 0, 0.2, 1);
}

/* Updated navigation list container and list styles */
.navigation-list-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  margin-top: 185px;
  padding-bottom: 4rem;
}

.navigation-list {
  height: calc(100vh - 160px);
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding-bottom: 3rem;
}

/* Add this new block for mini mode */
.v-navigation-drawer--mini-variant .navigation-list {
  height: calc(97vh - 130px);
}

.navigation-list::-webkit-scrollbar {
  display: none;
}

.toggle-btn {
  position: fixed !important;
  bottom: 2rem !important;
  right: -8.5px !important;
  transform: none !important;
  z-index: 2;
  transition: all var(--drawer-transition-speed) cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  width: 22px !important;
  height: 22px !important;
  background: transparent !important;
  box-shadow: none !important;
}

.toggle-btn .v-icon {
  font-size: 22px !important;
  margin-left: 0 !important;
  padding: 0 !important;
}

.toggle-btn:hover {
  opacity: 0.8;
}

.toggle-btn::before {
  display: none !important;
}

.nav-list-item {
  padding: 4px 8px !important;
  min-height: 39px !important;
  margin-bottom: 2px !important;
  display: flex;
  align-items: center;
}

.mini-list-item {
  justify-content: center !important;
  padding: 4px 0 4px 8px !important;
  transform: translateX(6px) !important;
}

.icon-wrapper {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50% !important;
  min-width: 36px !important;
  width: 36px !important;
  height: 36px !important;
  transition: all var(--drawer-transition-speed) cubic-bezier(0.4, 0, 0.2, 1);
  margin-right: 12px !important;
}

.mini-list-item .icon-wrapper {
  margin: 0 auto !important;
}

.mini-icon-wrapper {
  margin-right: 0 !important;
}

/* Active route styling */
.v-list-item--active {
  background-color: rgba(var(--v-primary-base), 0.1) !important;
}

.v-list-item--active .icon-wrapper {
  background-color: var(--v-primary-base) !important;
}

/* Hover effects */
.v-list-item:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

/* Mini mode specific adjustments */
.v-navigation-drawer--mini-variant .navigation-list-container {
  margin-top: 80px;
  padding-top: calc(var(--header-height) + 1rem);
}

.v-navigation-drawer--mini-variant .nav-list-item {
  padding: 4px 0 !important;
  margin-bottom: 4px !important;
}

.v-navigation-drawer--mini-variant .icon-wrapper {
  margin: 0 auto !important;
}

/* Set base dimensions for all list items in mini mode */
.v-navigation-drawer--mini-variant .v-list-item {
  width: 44px !important;
  height: 44px !important;
  margin: 4px auto !important;
  border-radius: 22px !important;
  padding: 4px !important;
}

/* Active state adjustments in mini mode */
.v-navigation-drawer--mini-variant .v-list-item--active {
  background-color: rgba(var(--v-primary-base), 0.14) !important;
}

/* Dark theme adjustments */
.theme--dark .v-navigation-drawer--mini-variant .v-list-item--active {
  background-color: rgba(var(--v-primary-base), 0.08) !important;
}

.theme--dark .v-navigation-drawer--mini-variant .v-list-item:hover {
  background-color: rgba(255, 255, 255, 0.03) !important;
}

/* Hover state in mini mode */
.v-navigation-drawer--mini-variant .v-list-item:hover {
  background-color: rgba(0, 0, 0, 0.08) !important;
}

/* Tooltip styling */
.v-tooltip__content {
  color: black !important;
  opacity: 1 !important;
  font-size: 12px !important;
  padding: 4px 8px !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .toggle-btn {
    display: none !important;
  }

  .fixed-image {
    left: 3rem;
  }

  .fixed-image.mini-mode {
    left: 0.5rem;
  }
}

/* Smooth transitions for all interactive elements */
.v-list-item,
.v-list-item__content,
.v-list-item__title {
  transition: all var(--drawer-transition-speed) cubic-bezier(0.4, 0, 0.2, 1) !important;
}
</style>
